import { render } from "./preDrillingTable.vue?vue&type=template&id=16d2832d&scoped=true"
import script from "./preDrillingTable.vue?vue&type=script&lang=js"
export * from "./preDrillingTable.vue?vue&type=script&lang=js"

import "./preDrillingTable.vue?vue&type=style&index=0&id=16d2832d&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d2832d"]])

export default __exports__